import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import EnquiryForm from "@/components/site/EnquiryForm";

/** Any link to "#contact" opens the WhatsApp enquiry form in a popup instead of scrolling. */
const ContactDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const a = (e.target as HTMLElement)?.closest?.("a");
      const href = a?.getAttribute("href") || "";
      if (href === "#contact" || href === "/#contact") {
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl gap-3 rounded-3xl border-0 [&_form]:gap-3 [&_input]:py-2 [&_select]:py-2 [&_textarea]:min-h-20 [&_button[type=submit]]:py-3 bg-gradient-to-br from-primary to-[hsl(194_100%_36%)] p-6 text-primary-foreground md:p-8 [&>button]:text-primary-foreground">
        <DialogTitle className="text-2xl font-bold tracking-tight text-primary-foreground">Get in touch</DialogTitle>
        <DialogDescription className="text-primary-foreground">
          Tell us what you need. It opens WhatsApp with your answers ready to send.
        </DialogDescription>
        <EnquiryForm />
      </DialogContent>
    </Dialog>
  );
};

export default ContactDialog;
